export default __webpack_public_path__ + "static/media/icon_review_smile.856bb372.svg";